import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Header from "src/common/components/layout-old/Header";
import Footer from "src/common/components/layout-old/Footer";
import { Outlet } from "react-router-dom";
import "./PublicLayout.scss";
function PublicLayout() {
    return (_jsxs("div", { className: "public-layout", children: [_jsx(Header, {}), _jsx("main", { children: _jsx(Outlet, {}) }), _jsx(Footer, {})] }));
}
export default PublicLayout;
